import {
  PaccJobCurationDto,
  PaccJobCurationFitScoreDto,
  PaccJobCurationResultRs,
} from '@domain/rs/phs/pacc/competence/PaccJobCurationResultRs';
import { JobCurationResultType } from '@domain/constant/jobCurationResultType';
import { FitType } from '@domain/constant/fitType';

export class PaccJobCurationFitScoreVO {
  fitType: FitType;
  score: number;
  priority: number;

  constructor(dto: PaccJobCurationFitScoreDto) {
    this.fitType = dto.fitType;
    this.score = dto.score;
    this.priority = dto.priority;
  }
}

export class PaccJobCurationVO {
  jobTitleCode: number;
  jobTitleName: string;
  score: number;
  resultType: JobCurationResultType;
  priority: number;
  description: string;
  keyword: string;
  comment: string;
  fitScores: PaccJobCurationFitScoreVO[];

  constructor(dto: PaccJobCurationDto) {
    this.jobTitleCode = dto.jobTitleCode;
    this.jobTitleName = dto.jobTitleName;
    this.score = dto.score;
    this.resultType = dto.resultType;
    this.priority = dto.priority;
    this.description = dto.description;
    this.keyword = dto.keyword;
    this.comment = dto.comment;
    this.fitScores = dto.fitScores?.map((dto) => new PaccJobCurationFitScoreVO(dto));
  }
}

export class PaccJobCurationResultVO {
  sn: number;
  jobCurations: PaccJobCurationVO[];

  constructor(rs: PaccJobCurationResultRs) {
    this.sn = rs.sn;
    this.jobCurations = rs.jobCurations?.map((dto) => new PaccJobCurationVO(dto)).sort((a, b) => b.score - a.score);
  }
}
